<template>
    <section class="content">
        <div class="container-fluid unselectable">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
                    <div class="card bg-light d-flex flex-fill">
                        <div class="card-header text-muted border-bottom-0">
                        Mata Pelajaran
                        </div>
                        <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-12">
                            <h2 class="lead"><b>{{ materi.mapel }}</b></h2>
                            <!-- <p class="text-muted text-sm"><b>Info </b> Web Designer / UX / Graphic Artist / Coffee Lover </p>                             -->
                            </div>
                        </div>
                        </div>
                        <div class="card-footer">
                        <div class="text-right">     
                            <router-link :to='{
                                path: "/materi-ajar-content/"+materi.mapel_id
                            }' class="btn btn-sm btn-secondary">
                            <i class="fas fa-arrow-left"></i> Ke Daftar Materi
                          </router-link>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-8 d-flex align-items-stretch flex-column">
                    <div class="card bg-light d-flex flex-fill">
                        <div class="card-header text-muted border-bottom-0">
                        Materi
                        </div>
                        <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-12">
                            <h2 class="lead"><b>{{ materi.title }}</b></h2>
                            <!-- <p class="text-muted text-sm"><b>Info </b> Web Designer / UX / Graphic Artist / Coffee Lover </p>                             -->
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card card-outline card-info">
                <div class="card-header">
                <h3 class="card-title">
                    {{ materi.title }}
                </h3>
                </div>
            <div class="card-body">
            <div class="content px-2" v-if="false">
                    <h1 id="contributing-to-adminlte">Contributing to AdminLTE</h1>

                <p>Contributions are always <strong>welcome and recommended</strong>! Here is how for beginner’s: <a href="https://youtu.be/GbqSvJs-6W4">Get started with open source click here</a></p>

                <ol>
                <li>Contribution Requirements :
                    <ul>
                    <li>When you contribute, you agree to give a non-exclusive license to AdminLTE.io to use that contribution in any context as we (AdminLTE.io) see appropriate.</li>
                    <li>If you use content provided by another party, it must be appropriately licensed using an <a href="https://opensource.org/licenses">open source</a> license.</li>
                    <li>Contributions are only accepted through GitHub pull requests.</li>
                    <li>Finally, contributed code must work in all supported browsers (see above for browser support).</li>
                    </ul>
                </li>
                <li>Installation :
                    <ul>
                    <li>Fork the repository (<a href="https://help.github.com/articles/fork-a-repo/">here is the guide</a>).</li>
                    <li>Clone to your machine</li>
                    </ul>

                    <div class="language-bash highlighter-rouge"><div class="highlight"><pre class="highlight"><code> git clone https://github.com/YOUR_USERNAME/AdminLTE.git
                </code></pre></div>    </div>
                    <ul>
                    <li>Create a new branch</li>
                    </ul>
                </li>
                <li>Compile dist files (Development) :
                    <ul>
                    <li>To compile the dist files you need Node.js 10 or higher/npm (node package manager)</li>
                    <li>Delete ./package-lock.json file</li>
                    <li><code class="language-plaintext highlighter-rouge">npm install</code> (install npm deps)</li>
                    <li><code class="language-plaintext highlighter-rouge">npm run dev</code> (developer mode, autocompile with browsersync support for live demo)</li>
                    <li>Make your changes only in ./buid Folder OR package.json OR ./dist/js/demo.js OR in any html files which nessary to contribute</li>
                    <li>Do not changes in ./dist/css/ AND ./dist/js/ Because its compiled files</li>
                    <li><code class="language-plaintext highlighter-rouge">npm run production</code> (compile css/js files and test every pages are perfectly working fine, before creating pull request)</li>
                    </ul>
                </li>
                <li>Create a pull request</li>
                </ol>

                <h2 id="online-one-click-setup-for-contributing">Online one-click setup for contributing</h2>

                <p>You can use Gitpod(an online IDE which is free for Open Source) for working on issues or making Prs. With a single click it will launch a workspace and automatically:</p>

                <ul>
                <li>clone the <code class="language-plaintext highlighter-rouge">AdminLTE</code> repo.</li>
                <li>install the dependencies.</li>
                <li>run <code class="language-plaintext highlighter-rouge">npm run dev</code> to start the server.</li>
                </ul>

                <p><a href="https://gitpod.io/from-referrer/"><img src="https://gitpod.io/button/open-in-gitpod.svg" alt="Open in Gitpod"></a></p>

            </div>
            <div class="content">
                <div v-html="materi.content"></div>
            </div>
            </div>
            <div class="card-footer" v-if="false">
              LBB Taruna Cendekia :: documentation for more examples and information about the plugin.
            </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { authFetch } from "@/libs/hxcore";
import $ from "jquery";
    export default {
    name: 'MateriDetail',
    data: () => ({
      materi: {},
	  roles: "",
	  materi_id: "",
    }),
    created: function () {
        let id = this.$route.params.id;
        this.loadMateri(id);
        // this.materi_id = id;

		this.roles = this.$route.meta.roles;
    	console.log("load initial data", this.$route);
    },
    methods: {
        loadMateri(id){
			authFetch("/siswa/materi/detail/" + id).then((res) => {
				res.json().then((json) => {
				this.materi = json;
				// console.log(this.materi);
				});
			});
        },
    },
    mounted(){
	const e = this.$refs;
	let self = this;

    $(document).ready(function() {
        $(".content").on("contextmenu", function(e) {
            return false;
        });
    });
    }
}
</script>
<style type="text/css" scoped>
.unselectable {
    -webkit-user-select: none;
    -webkit-touch-callout: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.card-info .card-body .content {
    overflow: auto;
}
</style>